<template>
    <v-card flat class="mt-5">
        <v-tabs
            ref="tabs"
            v-model="activeTab"
            background-color="white"
            color="primary"
            centered
            :key="tabsKey"
        >
            <v-tab v-for="tab of tabs" :key="tab.id" :to="tab.route" @change="setTabActive(tab.id)" exact>
                {{ tab.name }}
            </v-tab>

            <v-tabs-items v-model="activeTab">
                <router-view></router-view>
            </v-tabs-items>
        </v-tabs>
    </v-card>
</template>

<script>
export default {
    name: 'detail-tab-corporate',
    props: ['id'],
    data: function () {
        return {
            name: '',
            activeTabId: 1,
            tabsKey: 0,
            activeTab: `${this.$route.meta.basePath}/detalhe/${this.id}/societario/captable`,
            tabs: [
                { id: 1, name: this.$t('corporate.tabs.captable'), route: `${this.$route.meta.basePath}/detalhe/${this.id}/societario/captable` },
                { id: 2, name: this.$t('corporate.tabs.administration'), route: `${this.$route.meta.basePath}/detalhe/${this.id}/societario/administracao` },
                { id: 3, name: this.$t('corporate.tabs.constitutiveActs'), route: `${this.$route.meta.basePath}/detalhe/${this.id}/societario/atos-constitutivos` }
            ]
        }
    },
    watch: {
        '$route': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.activeTab = `${this.$route.meta.basePath}/detalhe/${this.id}/societario/captable`
                    this.tabs = [
                        { id: 1, name: this.$t('corporate.tabs.captable'), route: `${this.$route.meta.basePath}/detalhe/${this.id}/societario/captable` },
                        { id: 2, name: this.$t('corporate.tabs.administration'), route: `${this.$route.meta.basePath}/detalhe/${this.id}/societario/administracao` },
                        { id: 3, name: this.$t('corporate.tabs.constitutiveActs'), route: `${this.$route.meta.basePath}/detalhe/${this.id}/societario/atos-constitutivos` }
                    ]
                    this.$refs.tabs.callSlider()
                }
            },
            deep: true
        }
    },
    methods: {
        setTabActive (index) {
            this.activeTabId = index
        }
    }
}
</script>
